import axios from 'axios';

const talk_notifieds = {
  namespaced: true,
  state() {
    return {
      data: {
        notifieds: [],
        is_show: false,
      },
    };
  },
  mutations: {
    setData(state, data) {
      state.data.notifieds = data;
    },
    setShowNotificationList(state, payload) {
      state.data.is_show = payload.value;
    },
  },
  actions: {
    load({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/talks/me')
          .then((response) => {
            commit('setData', response.data.data);
            resolve(true);
          })
          .catch(() => reject());
      });
    },
  },
  getters: {
    existsUnreadTalk(state) {
      return state.data.notifieds.length > 0;
    }
  },
};

export default talk_notifieds;
